module.exports = __webpack_public_path__ + "static/media/cliente-vetbr.e1e7b604.webp";